export default "__VITE_ASSET__CBPeqfYD__"